import React, { useState, useEffect } from "react";
import { Container, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Input, Col } from 'reactstrap';
import { Formik, Form, FieldArray } from "formik";
import { Loading } from '../../share/loading'
import * as Yup from 'yup'
import '../../share/form.css';
import Swal from 'sweetalert2'
import '../../SupportSystem/Reports/reportall.css';
import * as XLSX from "xlsx";

// import { format } from "date-fns";
import { NumberWithCommmas2 } from "../../share/NumberWithCommmas2";



export function NewReportAllocatedAndSubsidies38Component() {
    const [data, setData] = useState([]);
    const [selectSupport, setSelectSupport] = useState([])
    const [loading, setLoading] = useState(false);
    const user = JSON.parse(localStorage.getItem("userData"));
    const [openModal, setOpenModal] = useState(false);
    const ToggleModal = () => setOpenModal(!openModal);

    useEffect(() => {
        getdatafromview();
    }, []);

    const grouped = React.useMemo(() => {
        const bySupport = new Map();

        (data ?? []).forEach((item) => {
            const key = item.supportNo ?? String(item.supportId ?? "");
            if (!bySupport.has(key)) {
                bySupport.set(key, {
                    supportNo: item.supportNo,
                    supportName: item.supportName,
                    // ถ้ามีฟิลด์แยก "amountRequested/amountApproved" ให้เปลี่ยนมาใช้แทน
                    amountReq: item.amount,
                    amountAppr: item.amount,
                    details: [],
                });
            }
            bySupport.get(key).details.push({
                createDate: item.createDate,
                total: item.total,
                cer2ApproveDate: item.cer2ApproveDate,
                careerName: item.careerName,
                occupationName: item.occupationName,
                testDate: item.testDate, // ถ้าไม่มีให้เป็น undefined แล้วค่อย fallback เป็น "-"
                employeeTotal: item.employeeTotal,
                personTotal: item.personTotal,
                payRateStartDate: item.payRateStartDate,
                payRateEndDate: item.payRateEndDate,
                countPerson: item.countPerson,
            });
        });

        return Array.from(bySupport.values());
    }, [data]);

    async function getdatafromview() {
        setLoading(true);
        try {
            let res = await fetch("/api/SupportAllowCate/listAllocated38", {
                method: "POST",
                headers: { 'token': user.token },
            });
            const data = await res.json();
            // console.log("data.dataenum2", data.dataenum);
            setData(data.dataenum);
            setSelectSupport(data.dataenum.filter((v, i, arr) => arr.findIndex(v2 => (v2.supportId === v.supportId)) === i)) //filter เอา id ที่ซ้ำกันออก แล้วเอา array ตัวนี้ไปให้ user เลือก ตอนที่จะกด export
            // setYearData(dataYear.dataenum);
        } catch (e) {
            console.log("err =>" + e);
        } finally {
            setLoading(false);
        }
    }

    const ExportSupport = async (values) => {
        setLoading(true);
        try {
            // 0) เลือกเฉพาะที่ติ๊ก
            const picked = (values?.selectExportAr || []).filter(v => v.status);
            if (!picked.length) {
                await Swal.fire({
                    icon: "error",
                    title: "กรุณาเลือกอย่างน้อย 1 รายการ",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
                return;
            }

            // 1) กรองข้อมูลบนหน้า ให้เหลือเฉพาะ support ที่เลือก
            const selectedIdSet = new Set(picked.map(p => p.supportId));
            const selectedNoSet = new Set(picked.map(p => p.supportNo));
            const rows = (data || []).filter(it =>
                selectedIdSet.has(it.supportId) || selectedNoSet.has(it.supportNo)
            );

            // 2) group ตาม supportNo เพื่อทำ merge แนวตั้ง (A,B,D,O,P)
            const groupedMap = new Map();
            rows.forEach((it) => {
                const key = it.supportNo ?? String(it.supportId ?? "");
                if (!groupedMap.has(key)) {
                    groupedMap.set(key, {
                        supportId: it.supportId,
                        supportNo: it.supportNo,
                        supportName: it.supportName,
                        amountReq: Number(it.amount ?? 0) || 0,
                        amountAppr: Number(it.amount ?? 0) || 0, // ถ้ามีฟิลด์อนุมัติแยก ให้เปลี่ยนมาใช้
                        details: [],
                    });
                }
                groupedMap.get(key).details.push({
                    createDate: it.createDate || "-",
                    total: it.total == null ? "" : Number(it.total), // จำนวน (ตัวเลขดีกว่า)
                    cer2ApproveDate: it.cer2ApproveDate || "-",
                    careerName: it.careerName || "-",
                    occupationName: it.occupationName || "-",
                    testDate: it.testDate || "-", // ถ้าไม่มี field นี้ก็จะเป็น "-"
                    employeeTotal: it.employeeTotal == null ? "" : Number(it.employeeTotal),
                    personTotal: it.personTotal == null ? "" : Number(it.personTotal),
                    payRateStartDate: it.payRateStartDate || "-",
                    payRateEndDate: it.payRateEndDate || "-",
                    countPerson: it.countPerson == null ? "" : Number(it.countPerson),
                });
            });
            const grouped = Array.from(groupedMap.values());

            // 3) สร้าง header 3 แถว + merges
            const aoa = [
                // แถว 1
                [
                    "ที่", "เลขที่คำขอ", "วันที่รับคำขอ", "ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน",
                    "ประกาศข้อ ๔",
                    "ประกาศข้อ ๗", "", "", "", "", "",
                    "ประกาศข้อ ๘", "", "",
                    "จำนวนเงินที่ขอรับ (บาท)", "จำนวนเงินที่อนุมัติ (บาท)"
                ],
                // แถว 2
                [
                    "", "", "", "",
                    "จำนวนผู้ผ่านการทดสอบในสาขาอาชีพ ตามประกาศอัตราค่าจ้าง ตามมาตรฐานฝีมือและส่งเงินค่าทดสอบเข้ากองทุน ในปีที่ผ่านมา",
                    "วันที่ให้หนังสือรับรองตามมาตรา 26 (วัน/เดือน/ปี)", "สาขาอาชีพ", "สาขา", "วันที่ดำเนินการทดสอบ (วัน/เดือน/ปี)",
                    "จำนวนลูกจ้างทั้งหมดในตำแหน่งงานที่ดำเนินการทดสอบมาตรฐานฝีมือแรงงานตามมาตรา 26 (คน)",
                    "จำนวนผู้เข้ารับการทดสอบมาตรฐานฝีมือแรงงานตามมาตรา 26 (คน)",
                    "วันที่จ่ายค่าจ้างตามมาตรฐาน", "",
                    "จำนวนผู้ผ่านการทดสอบ (คน)", "", ""
                ],
                // แถว 3
                [
                    "", "", "", "",
                    "", "", "", "", "", "", "",
                    "ตั้งแต่วันที่", "ถึงวันที่",
                    "", "", ""
                ],
            ];

            // merges (0-based index)
            const merges = [
                { s: { r: 0, c: 0 }, e: { r: 2, c: 0 } }, // A1:A3
                { s: { r: 0, c: 1 }, e: { r: 2, c: 1 } }, // B1:B3
                { s: { r: 0, c: 2 }, e: { r: 2, c: 2 } }, // C1:C3
                { s: { r: 0, c: 3 }, e: { r: 2, c: 3 } }, // D1:D3
                { s: { r: 0, c: 5 }, e: { r: 0, c: 10 } },// F1:K1
                { s: { r: 0, c: 11 }, e: { r: 0, c: 13 } },// L1:N1
                { s: { r: 1, c: 4 }, e: { r: 2, c: 4 } }, // E2:E3
                { s: { r: 1, c: 5 }, e: { r: 2, c: 5 } }, // F2:F3
                { s: { r: 1, c: 6 }, e: { r: 2, c: 6 } }, // G2:G3
                { s: { r: 1, c: 7 }, e: { r: 2, c: 7 } }, // H2:H3
                { s: { r: 1, c: 8 }, e: { r: 2, c: 8 } }, // I2:I3
                { s: { r: 1, c: 9 }, e: { r: 2, c: 9 } }, // J2:J3
                { s: { r: 1, c: 10 }, e: { r: 2, c: 10 } }, // K2:K3
                { s: { r: 1, c: 11 }, e: { r: 1, c: 12 } }, // L2:M2
                { s: { r: 1, c: 13 }, e: { r: 2, c: 13 } }, // N2:N3
                { s: { r: 0, c: 14 }, e: { r: 2, c: 14 } }, // O1:O3
                { s: { r: 0, c: 15 }, e: { r: 2, c: 15 } }, // P1:P3
            ];

            // 4) เติมข้อมูล + merge แนวตั้งตาม group
            let rowIndex = aoa.length; // เริ่มที่แถว 4 (index = 3)
            let order = 1;
            const topAmountCells = []; // เก็บตำแหน่ง top-left ของคอลัมน์ O,P เพื่อใส่ number format

            grouped.forEach((g) => {
                const start = rowIndex;
                g.details.forEach((d, di) => {
                    aoa.push([
                        di === 0 ? order : "",
                        di === 0 ? (g.supportNo || "-") : "",
                        d.createDate,
                        di === 0 ? (g.supportName || "-") : "",
                        d.total,                // E ข้อ 4 (ตัวเลขได้)
                        d.cer2ApproveDate,      // F
                        d.careerName,           // G
                        d.occupationName,       // H
                        d.testDate,             // I
                        d.employeeTotal,        // J (ตัวเลขได้)
                        d.personTotal,          // K (ตัวเลขได้)
                        d.payRateStartDate,     // L
                        d.payRateEndDate,       // M
                        d.countPerson,          // N (ตัวเลขได้)
                        di === 0 ? g.amountReq : "",
                        di === 0 ? g.amountAppr : "",
                    ]);
                    rowIndex++;
                });
                const end = rowIndex - 1;

                // merge คอลัมน์ A,B,D,O,P ถ้ากลุ่มนี้มี > 1 แถว
                if (end > start) {
                    merges.push({ s: { r: start, c: 0 }, e: { r: end, c: 0 } });  // A
                    merges.push({ s: { r: start, c: 1 }, e: { r: end, c: 1 } });  // B
                    merges.push({ s: { r: start, c: 3 }, e: { r: end, c: 3 } });  // D
                    merges.push({ s: { r: start, c: 14 }, e: { r: end, c: 14 } });// O
                    merges.push({ s: { r: start, c: 15 }, e: { r: end, c: 15 } });// P
                }
                // จำตำแหน่งบนสุดของ O,P สำหรับใส่ number format
                topAmountCells.push({ r: start, c: 14 });
                topAmountCells.push({ r: start, c: 15 });

                order++;
            });

            // 5) สร้าง sheet แล้วใส่ merges / width / number format
            const ws = XLSX.utils.aoa_to_sheet(aoa);
            ws['!merges'] = merges;
            ws['!cols'] = [
                { wch: 6 }, { wch: 16 }, { wch: 16 }, { wch: 36 }, { wch: 20 },
                { wch: 22 }, { wch: 18 }, { wch: 16 }, { wch: 22 }, { wch: 22 },
                { wch: 22 }, { wch: 16 }, { wch: 16 }, { wch: 18 }, { wch: 20 }, { wch: 20 }
            ];

            // ใส่ number format ให้คอลัมน์ O,P เฉพาะ cell บนสุดของ merge
            topAmountCells.forEach(({ r, c }) => {
                const addr = XLSX.utils.encode_cell({ r, c });
                if (ws[addr]) {
                    ws[addr].t = 'n';
                    ws[addr].z = '#,##0.00';
                }
            });

            // 6) เขียนไฟล์ (ฝั่งหน้า)
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "แบบคำขอฯ");
            XLSX.writeFile(wb, "แบบขอรับการจัดสรรเงินช่วยเหลือหรืออุดหนุน.xlsx");

            // 7) อัปเดตสถานะหลังบ้าน (ส่ง supportId[])
            let formData = new FormData();
            let supportIdAr = Array.from(new Set(picked.map(p => p.supportId))).filter(Boolean);
            console.log(supportIdAr)
            supportIdAr.forEach(item => formData.append("supportIds", item))
            const updateRes = await fetch("/api/SupportAllowCate/updateStatusSupportAllocate", {
                method: "POST",
                body: formData
              
            });
            if (!updateRes.ok) throw new Error("อัปเดตสถานะไม่สำเร็จ");

            await Swal.fire({
                icon: "success",
                title: "ส่งออกสำเร็จ",
                text: "ได้ทำการอัปเดตสถานะเรียบร้อยแล้ว",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            });

            ToggleModal();
            await getdatafromview();
        } catch (err) {
            console.error(err);
            await Swal.fire({
                icon: "error",
                title: "เกิดข้อผิดพลาด",
                text: err?.message || "ไม่สามารถทำรายการได้",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            });
        } finally {
            setLoading(false);
        }
    };


    const initialValues = {
        selectExportAr: selectSupport.map((item) => ({
            supportId: item?.supportId,
            status: false,
        })),
    }
    const validateSchema = Yup.object().shape({

    })


    if (loading) { return <Loading /> }
    return (

        <Container >
            <center>
                <Label
                    for=""
                >
                    แบบขอรับการจัดสรรเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน ประจำปีงบประมาณ พ.ศ.
                    {data != null && data.length > 0 ? (
                        data[0]?.budgetYear
                    ) : (
                        null
                    )}
                </Label>
            </center>
            <center>
                <Label
                    for=""
                >
                    ตามประกาศคณะกรรมการส่งเสริมการพัฒนาฝีมือแรงงาน
                </Label>
            </center>
            <center>
                <Label
                    for=""
                >
                    เรื่อง หลักเกณฑ์การใช้จ่ายเงินเพื่อช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน ลงวันที่ 31 มีนาคม พ.ศ. 2568
                </Label>
            </center>

            <div className="d-flex w-100 align-items-center justify-content-end mb-3">
                <button
                    onClick={ToggleModal}
                    disabled={selectSupport.length === 0 && selectSupport != null && selectSupport != undefined}
                    // onClick={() => {
                    //     window.open(`api/SupportReports/getExeclthirtyeight`, '_blank');


                    // }} download
                    className="btn-green p-2 w-25">Export Excel</button>

            </div>
            <div className="outer-wrapper">
                <div className="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th rowSpan="3">ที่</th>
                                <th rowSpan="3">เลขที่คำขอ</th>
                                <th rowSpan="3">วันที่รับคำขอ</th>
                                <th rowSpan="3">ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน</th>

                                {/* กลุ่มหัว “ประกาศข้อ ๔” = 2 คอลัมน์ */}
                                <th colSpan={1}>ประกาศข้อ ๔</th>

                                {/* กลุ่มหัว “ประกาศข้อ ๗” = 3 คอลัมน์ */}
                                <th colSpan={6}>ประกาศข้อ ๗</th>

                                {/* กลุ่มหัว “ประกาศข้อ ๘” = 3 คอลัมน์ */}
                                <th colSpan={3}>ประกาศข้อ ๘</th>

                                <th rowSpan="3">จำนวนเงินที่ขอรับ (บาท)</th>
                                <th rowSpan="3">จำนวนเงินที่อนุมัติ (บาท)</th>
                            </tr>

                            <tr>
                                {/* ประกาศข้อ ๔ (รายละเอียดแถว 2) */}
                                <th rowSpan={2}>
                                    จำนวนผู้ผ่านการทดสอบในสาขาอาชีพ
                                    ตามประกาศอัตราค่าจ้าง ตามมาตรฐานฝีมือและส่งเงินค่าทดสอบเข้ากองทุน
                                    ในปีที่ผ่านมา
                                </th>

                                {/* ประกาศข้อ ๗ (รายละเอียดแถว 2) */}
                                <th rowSpan={2}>
                                    วันที่ให้หนังสือรับรองตามมาตรา 26<br />(วัน/เดือน/ปี)
                                </th>
                                <th rowSpan={2}>
                                    สาขาอาชีพ
                                </th>
                                <th rowSpan={2}>
                                    สาขา
                                </th>
                                <th rowSpan={2}>
                                    วันที่ดำเนินการทดสอบ<br />(วัน/เดือน/ปี)
                                </th>
                                <th rowSpan={2}>
                                    จำนวนลูกจ้างทั้งหมดในตำแหน่งงานที่ดำเนินการทดสอบมาตรฐานฝีมือแรงงานตามมาตรา 26<br />(คน)
                                </th>
                                <th rowSpan={2}>
                                    จำนวนผู้เข้ารับการทดสอบมาตรฐานฝีมือแรงงานตามมาตรา 26<br />(คน)
                                </th>

                                {/* ประกาศข้อ ๘ (รายละเอียดแถว 2) */}
                                <th colSpan={2}>
                                    วันที่จ่ายค่าจ้างตามมาตรฐาน
                                </th>
                                <th rowSpan={2}>
                                    จำนวนผู้ผ่านการทดสอบ<br />(คน)
                                </th>
                            </tr>

                            <tr>
                                {/* ประกาศข้อ ๘ – คอลัมน์วันที่ */}
                                <th>ตั้งแต่วันที่</th>
                                <th>ถึงวันที่</th>


                            </tr>
                        </thead>

                        <tbody>
                            {grouped.length > 0 ? (
                                grouped.map((g, gi) =>
                                    g.details.map((row, ri) => (
                                        <tr key={`${g.supportNo || 'key'}-${ri}`}>
                                            {/* ลำดับ (merge) */}
                                            {ri === 0 && (
                                                <td rowSpan={g.details.length} className="text-end">
                                                    {gi + 1}
                                                </td>
                                            )}

                                            {/* เลขที่คำขอ (merge) */}
                                            {ri === 0 && (
                                                <td rowSpan={g.details.length} className="text-end">
                                                    {g.supportNo || "-"}
                                                </td>
                                            )}

                                            {/* วันที่รับคำขอ (ไม่ merge) */}
                                            <td className="text-start">{row.createDate || "-"}</td>

                                            {/* ชื่อผู้ขอรับเงิน (merge) */}
                                            {ri === 0 && (
                                                <td rowSpan={g.details.length} className="text-start">
                                                    {g.supportName || "-"}
                                                </td>
                                            )}

                                            {/* ประกาศข้อ ๔ */}
                                            <td className="text-end">{row.total ?? "-"}</td>

                                            {/* ประกาศข้อ ๗ */}
                                            <td className="text-start">{row.cer2ApproveDate || "-"}</td>
                                            <td className="text-start">{row.careerName || "-"}</td>
                                            <td className="text-start">{row.occupationName || "-"}</td>
                                            <td className="text-center">{row.testDate || "-"}</td>
                                            <td className="text-end">{row.employeeTotal ?? "-"}</td>
                                            <td className="text-end">{row.personTotal ?? "-"}</td>

                                            {/* ประกาศข้อ ๘ */}
                                            <td className="text-start">{row.payRateStartDate || "-"}</td>
                                            <td className="text-start">{row.payRateEndDate || "-"}</td>
                                            <td className="text-end">{row.countPerson ?? "-"}</td>

                                            {/* จำนวนเงินที่ขอรับ (merge) */}
                                            {ri === 0 && (
                                                <td rowSpan={g.details.length} className="text-end">
                                                    {g.amountReq != null ? NumberWithCommmas2(g.amountReq) : "-"}
                                                </td>
                                            )}

                                            {/* จำนวนเงินที่อนุมัติ (merge) */}
                                            {ri === 0 && (
                                                <td rowSpan={g.details.length} className="text-end">
                                                    {g.amountAppr != null ? NumberWithCommmas2(g.amountAppr) : "-"}
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                )
                            ) : (
                                <tr>
                                    {/* ทั้งตารางมี 16 คอลัมน์ */}
                                    <td className="text-center" colSpan={16}>ไม่มีข้อมูล</td>
                                </tr>
                            )}
                        </tbody>


                    </table>
                </div>
            </div>
            <Modal
                isOpen={openModal}
                toggle={ToggleModal}
                backdrop={'static'}
                keyboard={false}
                size="xl"
                className="modal-bordered"
                centered
            >
                <Formik
                    initialValues={initialValues}
                    validationSchema={validateSchema}
                    onSubmit={ExportSupport}
                >
                    {({ values, errors, handleChange, handleBlur, setFieldValue, handleSubmit }) => {
                        console.log("values", values);
                        //va;idate ปุ่ม export ก่อนที่จะ export ข้อมูลจริงๆ
                        const PreExport = () => {
                            let pass = false;
                            console.log(values)
                            values.selectExportAr.forEach(element => {
                                console.log("element", element)
                                if (element.status === true) {
                                    pass = true;
                                    return;
                                }
                            });
                            if (pass === false) {
                                Swal.fire({
                                    icon: "error",
                                    title: "กรุณาเลือกอย่างน้อย 1 รายการ",
                                    html: "",
                                    confirmButtonColor: "#0A66C2",
                                    confirmButtonText: "ตกลง",
                                })
                            } else {
                                Swal.fire({
                                    icon: "info",
                                    title: "ยืนยันการทำรายการหรือไม่ ?",
                                    html: "หากยืนยันการทำรายการแล้ว <br/>จะไม่สามารถเลือกผู้ขอรับเงินช่วยเหลือหรืออุดหนุนเดิมได้",
                                    confirmButtonColor: "#0A66C2",
                                    confirmButtonText: "ตกลง",
                                    showCancelButton: true,
                                    cancelButtonText: "ยกเลิก",
                                    cancelButtonColor: "#ff0000",
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        handleSubmit(values)
                                    }
                                });
                            }
                        }
                        return (
                            <Form>
                                <ModalHeader toggle={ToggleModal} className="">เลือกชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน</ModalHeader>
                                <ModalBody>
                                    <FieldArray name="selectExportAr">
                                        {(fieldArrayProps) => {
                                            return (
                                                <div className="d-flex flex-column mt-3">
                                                    {selectSupport.length > 0 && selectSupport != null && selectSupport != undefined && selectSupport.map((support, index) => (
                                                        <FormGroup row>
                                                            <Col>
                                                                <Label>
                                                                    <Input
                                                                        type="checkbox"
                                                                        className="cus-type"
                                                                        name={`selectExportAr[${index}].status`}
                                                                        onBlur={handleBlur}
                                                                        onChange={(e) => {
                                                                            handleChange(e)
                                                                            if (e.target.checked) {
                                                                                setFieldValue(e.target.name, true)
                                                                            } else {
                                                                                setFieldValue(e.target.name, false)
                                                                            }
                                                                        }} />
                                                                </Label>
                                                                <span className="ms-3">
                                                                    {support.supportName}
                                                                </span>
                                                            </Col>
                                                        </FormGroup>
                                                    ))}

                                                </div>
                                            )
                                        }}
                                    </FieldArray>
                                </ModalBody>
                                <ModalFooter className="d-flex justify-content-center align-items-center">
                                    <button
                                        disabled={!selectSupport.length}
                                        type="button"
                                        onClick={() => PreExport()}
                                        className="btn-green p-2 w-25">
                                        Export
                                    </button>
                                </ModalFooter>
                            </Form>
                        )
                    }}

                </Formik>

            </Modal>

        </Container>



    )
}